

















import { CV } from '@app/componentlib/common/types/CVTypes'
import { CvModule } from '@app/componentlib/src/store/modules/cvdata'
import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ga } from '@app/componentlib/src/application/analytics'

@Component<ColorThemePicker>({
  props: {
    selected: Object,
    text: String,
    title: String
  }
})

export default class ColorThemePicker extends Vue {
  /**
   * Props variables
   */
  selected: CV | undefined

  /**
   * Component state variables
   */
  selectedColorTheme: number | undefined | null = null
  colorLoading = false

  /**
   * Lifecycle
   */
  async mounted () {
    if(CvModule.colorTheme !== undefined) {
      //Make sure we run changeColor when se set a new selectedColotTheme
      await this.selectColorTheme(CvModule.colorTheme, false)
    } else {
      if(
        this.selected !== undefined &&
        this.selected.validColorThemes !== null &&
        this.selected.validColorThemes !== undefined
        ) {
        const defaultTheme = this.selected.validColorThemes.find(theme => theme ? theme.default === true : false)?.id
        if(defaultTheme !== undefined) {
          await this.selectColorTheme(defaultTheme, false)
        }
      }
    }
  }

  /**
   * Getters
   */
  get t () {
    return AppModule.translations
  }

  /**
   * Methods
   */
  async selectColorTheme (id: number, userInteraction: boolean) {
    if(this.colorLoading === false && this.selectedColorTheme !== id) {
      this.colorLoading = true
      this.selectedColorTheme = id
      await CvModule.changeColor(this.selectedColorTheme)
      if(userInteraction === true) {
        ga.event({
          action: 'Select Color Theme',
          category: 'CV Tool',
          label: this.selectedColorTheme.toString()
        })
      }
    } else {
      console.warn('You either already picked the colortheme or we are updating themecolors!')
    }
    this.colorLoading = false
  }
}
